import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

interface MessageState {
	unreadCount: number;
}

const initialState: MessageState = {
	unreadCount: 0,
};

export const messageSlice = createSlice({
	name: "message",
	initialState,
	reducers: {
		setUnreadCount: (state, { payload }: PayloadAction<number>) => {
			state.unreadCount = payload;
		},
	},
});

export const { setUnreadCount } = messageSlice.actions;
